<div class="ct-overlay">
  <div class="ct-modal">
    <img class="cm-icon" src="assets/icons/confirmation-icon.svg" alt="" />
    <p class="cm-msg-one">{{ confirmationMessage | translate }}</p>
    <div class="cm-btn-grp">
      <button (click)="onClickok()" class="cm-btn-dark">
        <span>{{ "OK" | translate }}</span>
        <img class="arrow-right-icon" src="assets/icons/arrow-right.svg"  alt="" />
      </button>
      <button (click)="onClickCancel()" class="cm-btn-light">
        {{ "Cancel" | translate }}
      </button>
    </div>
  </div>
</div>
